import { Button } from '@design-system/button';
import { Icon } from '@design-system/icon';
import clsx from 'classnames';
import { navigate } from 'gatsby';
import React, { FC } from 'react';

import { ExtendedNavigationLink } from '~/mappers/header/models';

import { useBrowserScreen } from '../ExtendedGlobalHeader/hooks/useBrowserScreen';
import {
  componentPropsMapper,
  identityEmpty,
  layoutClassNameMapping,
  LayoutKey,
  SUBMENU_TYPE_NAME,
  submenuComponentType,
  SubmenuType,
} from './utils';

type IProps = {
  navigation: ExtendedNavigationLink[];
  layout?: LayoutKey;
  activeKey: string;
  className?: string;
};

const ExtendedGlobalSubmenu: FC<IProps> = ({
  navigation,
  className = '',
  activeKey,
}) => {
  const { isDesktopView } = useBrowserScreen();
  const activeNavigation = navigation.find((item) => item.title === activeKey);
  if (!activeNavigation) return null;

  const layout = activeNavigation?.layout_type;
  const btnTitle = activeNavigation?.bottom_link?.title;
  const btnLink = activeNavigation?.bottom_link?.link[0]?.url;
  const handleButtonClick = () => {
    if (!btnLink) {
      return;
    }

    // Check if it's an external link
    if (/^https?:\/\//.test(btnLink)) {
      window.location.href = btnLink;

      return;
    }
    // Use Gatsby navigate for internal links
    navigate(btnLink);
  };

  const btn = (
    <div className="submenu__button--wrapper">
      {!isDesktopView && (
        <span className="submenu__button--icon" aria-hidden="true">
          <Icon size={15} icon="arrowRight" />
        </span>
      )}
      <span className="submenu__button--title">{btnTitle}</span>
    </div>
  );

  return (
    <div className={clsx('submenu', { 'submenu--isMobile': !isDesktopView })}>
      <div
        className={clsx(
          'submenu-grid',
          layoutClassNameMapping[layout],
          className
        )}
      >
        {activeNavigation?.submenu_items.map((item: SubmenuType) => {
          // eslint-disable-next-line no-underscore-dangle, no-undef
          const type = item.__typename as SUBMENU_TYPE_NAME;
          const Cmp = submenuComponentType[type];
          const mapProps = componentPropsMapper[type] ?? identityEmpty;

          const props = mapProps(item);

          return (
            <div key={item.id} className="wrapper-component">
              <Cmp {...props} />
            </div>
          );
        })}
      </div>
      {activeNavigation.title !== navigation[0].title && (
        <div className="submenu__btn-wrapper">
          <Button
            variant="primary"
            size="small"
            className="submenu__btn"
            onClick={handleButtonClick}
            aria-label={btnTitle}
          >
            {btn}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ExtendedGlobalSubmenu;
